// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nByl","content":"styles_content__26lkb"};